// src/components/common/MobileMenu.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const MenuContainer = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  background-color: ${colors.white};
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  z-index: 999;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const NavItem = styled.li`
  border-bottom: 1px solid rgba(0,0,0,0.05);
`;

const NavLink = styled(Link)`
  display: block;
  padding: 16px 24px;
  color: ${colors.primary};
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${colors.lightGray};
  }
`;

const NavButton = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 16px 24px;
  color: ${colors.primary};
  background: none;
  border: none;
  font-weight: 500;
  font-size: 16px;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${colors.lightGray};
  }
`;

const CtaButton = styled.button`
  background-color: ${colors.secondary};
  color: ${colors.white};
  margin: 16px 24px;
  border-radius: 4px;
  text-align: center;
  display: block;
  padding: 16px 24px;
  width: calc(100% - 48px);
  border: none;
  font-family: inherit;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
`;

const SubMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  background: ${colors.lightGray};
`;

const SubMenuItem = styled.li`
  border-bottom: 1px solid rgba(0,0,0,0.05);
`;

const MobileMenu = ({ isOpen, closeMenu, openConsultationModal, openMentorModal }) => {
  const [openSection, setOpenSection] = useState(null);
  const handleConsultationClick = () => {
    closeMenu();
    openConsultationModal();
  };

  const handleMentorClick = () => {
    closeMenu();
    openMentorModal();
  };

  const toggleSection = (key) => {
    setOpenSection((prev) => (prev === key ? null : key));
  };

  return (
    <MenuContainer isOpen={isOpen}>
      <nav>
        <NavList>
          <NavItem>
            <NavButton onClick={() => toggleSection('curriculum')}>
              커리큘럼 {openSection === 'curriculum' ? '▲' : '▼'}
            </NavButton>
            {openSection === 'curriculum' && (
              <SubMenu>
                <SubMenuItem><NavLink to="/java" onClick={closeMenu}>Java 기초 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/java-advanced" onClick={closeMenu}>Java 심화 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/c" onClick={closeMenu}>C 입문 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/react" onClick={closeMenu}>React 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/database" onClick={closeMenu}>데이터베이스 모델링 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/typescript" onClick={closeMenu}>TypeScript 과정</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/ai-coding" onClick={closeMenu}>AI 코딩 과정</NavLink></SubMenuItem>
              </SubMenu>
            )}
          </NavItem>
          <NavItem><NavLink to="/tuition" onClick={closeMenu}>회비 안내</NavLink></NavItem>
          <NavItem><NavLink to="/instructors" onClick={closeMenu}>강사진</NavLink></NavItem>
          <NavItem><NavLink to="/reviews" onClick={closeMenu}>수강생 후기</NavLink></NavItem>
          <NavItem>
            <NavButton onClick={() => toggleSection('about')}>
              클럽 소개 {openSection === 'about' ? '▲' : '▼'}
            </NavButton>
            {openSection === 'about' && (
              <SubMenu>
                <SubMenuItem><NavLink to="/about" onClick={closeMenu}>클럽 소개</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/learning-guide" onClick={closeMenu}>학습 가이드</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/faq" onClick={closeMenu}>자주 묻는 질문</NavLink></SubMenuItem>
                <SubMenuItem><NavLink to="/refund-policy" onClick={closeMenu}>환불 정책</NavLink></SubMenuItem>
              </SubMenu>
            )}
          </NavItem>
          <NavItem><NavButton onClick={handleConsultationClick}>교육상담 신청</NavButton></NavItem>
          <NavItem><CtaButton onClick={handleMentorClick}>멘토 신청</CtaButton></NavItem>
        </NavList>
      </nav>
    </MenuContainer>
  );
};

export default MobileMenu;